// extracted by mini-css-extract-plugin
export default {"formCheckbox":"FormCheckbox_formCheckbox__jKce0"};